import PictureBook from './PictureBook'
export default PictureBook



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/picturebook/index.jsx